import React, { useEffect, useRef, useState } from 'react';
import iconLike from '@/assets/image/icon-like.png'
import iconShare from '@/assets/image/icon-share.png'

import styles from './index.less';
import { getLike, like } from '@/services/api';
import { Modal, Popover } from 'antd';
import { imagePrefix } from '@/constants';
import { MTools } from '..';

interface IShareProps {
  businessType: number;
  businessId: string;
}

const Share: React.FC<IShareProps> = ({ businessType, businessId }) => {
  const [showAnimate, setShowAnimate] = useState(false)
  const [count, setCount] = useState(0)
  const [text, setText] = useState('')
  const [visible, setVisible] = useState(false)
  const timerRef = useRef<any>()
  const shareTimerRef = useRef<any>()

  useEffect(() => {
    getLikeCount()
    return () => {
      clearTimeout(timerRef.current)
      clearTimeout(shareTimerRef.current)
    }
  }, [])

  const getLikeCount = async () => {
    const result = await getLike(businessType, businessId)
    if (result.success) {
      if (+result.data) {
        setCount(+result.data)
      } else {
        setText('点赞')
      }
    } else {
      MTools.Tips('error', (result && (result.message)) || '系统异常，请刷新再试')
    }
  }

  const addLike = async () => {
    if (showAnimate) return
    setShowAnimate(true)
    timerRef.current = setTimeout(() => {
      setShowAnimate(false)
    }, 1500)
    const result = await like(businessType, businessId)
    if (result.success) {
      setCount(count + 1)
    } else {
      MTools.Tips('error', (result && (result.message)) || '系统异常，请刷新再试')
    }
  }

  const showShare = () => {
    setVisible(true)
    if (visible) return
    shareTimerRef.current = setTimeout(() => {
      setVisible(false)
    }, 2000)
  }

  return (
    <div className={styles.share}>
      {visible && <div
        className={styles.shareContent}>
        <img src={imagePrefix('share-tip.png')} alt="" />
      </div>}
      <div className={styles.index}>
        <div className={styles.share} onClick={showShare}>
          <img src={iconShare} alt="" />
          <div className={styles.text}>
            分享
          </div>
        </div>
        <div
          className={styles.like}
          onClick={addLike}>
          <div className={showAnimate ? styles.addAnimate : styles.add}>+1</div>
          <img
            src={iconLike}
            alt=""
            className={showAnimate ? styles.likeAnimate : ""}
          />
          <div className={styles.text} >
            点赞
          </div>
        </div>
      </div>
    </div>
  );
};

export default Share;
